import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-fill text-background-50 text-xl"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              97影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? isScrolled
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? isScrolled
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              影视库
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? isScrolled
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-white/20 text-white backdrop-blur-sm'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影片..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm border transition-all duration-300 w-48 focus:w-64 focus:outline-none ${
                  isScrolled
                    ? 'bg-background-100 border-background-200 text-foreground-900 placeholder-foreground-400 focus:border-primary-400'
                    : 'bg-white/15 border-white/20 text-white placeholder-white/50 focus:border-white/40 focus:bg-white/25'
                }`}
              />
              <i className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${
                isScrolled ? 'text-foreground-400' : 'text-white/60'
              }`}></i>
            </div>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-home-line mr-2"></i>首页
            </Link>
            <Link
              to="/category/all"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname.startsWith('/category')
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-film-line mr-2"></i>影视库
            </Link>
            <Link
              to="/about"
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-information-line mr-2"></i>关于我们
            </Link>
            <div className="px-4 pt-2">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索影片..."
                  className="w-full pl-9 pr-4 py-2.5 rounded-full text-sm border border-background-200 bg-background-100 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}